<ng-container *ngIf="loadingService.isLoading$ | async">
  <div class="loading"><i>
      <nx-spinner nxSize="large"></nx-spinner>
    </i></div>
</ng-container>

<div [ngClass]="{'root': true, 'maintenance': maintenanceService.isMaintenance }"
  *ngIf="maintenanceService.isMaintenance || (userService.getLoggedUser() | async)" ng-cloak>

  <app-topbar *ngIf="!maintenanceService.isMaintenance"></app-topbar>
  <router-outlet></router-outlet>

  <div *ngIf="!maintenanceService.isMaintenance">
    <app-footer></app-footer>
    <div>
      <app-modal></app-modal>
      <app-alert-notifications></app-alert-notifications>
    </div>
  </div>
</div>
